function toNumber(v) {
    if (v == null) return 0;
    const cleaned = String(v).trim()
        .replace(/[^\d.,-]/g, "")   // оставляем только цифры, запятую/точку и минус
        .replace(",", ".");
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
}

function fmt(x) {
    // Округляем до 2 знаков после запятой, если нужно
    const val = (Math.abs(x - Math.round(x)) < 1e-9)
        ? Math.round(x)
        : Number(x.toFixed(2));

    // Используем локаль 'ru-RU' для разделения пробелами
    return val.toLocaleString('ru-RU');
}

function recalcTotals() {
    const inputs = document.querySelectorAll('input[name^="order_"]');

    // Итоговые суммы
    let sumRrc = 0, sumDealer = 0, sumWay = 0, sumProduction = 0, sumPreorder = 0;

    // Выходы (если есть на странице)
    const outRrc    = document.getElementById("total-rrc");
    const outDealer = document.getElementById("total-dealer");
    const outWay = document.getElementById("total-way");
    const outProduction = document.getElementById("total-production");
    const outPreorder = document.getElementById("total-preorder");

    // Табличка «Вы выбрали»
    const tbody = document.getElementById("selection-body");
    const summaryWrap  = document.getElementById("selection-summary");
    const summaryTitle = document.getElementById("summary-title"); // если используете заголовок
    if (tbody) tbody.innerHTML = ""; // очистить

    inputs.forEach(inp => {
        const qty = toNumber(inp.value);
        if (!qty) return;

        var pRrc    = toNumber(inp.getAttribute("data-price-rrc"));
        var pDealer = toNumber(inp.getAttribute("data-price-dealer"));
        var pWay = Math.ceil(toNumber(inp.getAttribute("data-price-way")));
        var pProduction = Math.ceil(toNumber(inp.getAttribute("data-price-production")));
        var pPreorder = Math.ceil(toNumber(inp.getAttribute("data-price-preorder")));
        if (pRrc == 0) pRrc = pDealer;

        sumRrc    += qty * pRrc;
        sumDealer += qty * pDealer;
        sumWay += qty * pWay;
        sumProduction += qty * pProduction;
        sumPreorder += qty * pPreorder;

        // Данные строки для «Вы выбрали»
        if (tbody) {
        const row        = inp.closest("tr");
        const groupBody  = row?.closest("tbody.group");
        const nomen      = (groupBody?.dataset?.nomenclature || "").trim();
        const feature    = (row?.querySelector(".cell-feature")?.innerText || "").trim();

        // Добавляем строку в таблицу
        const tr = document.createElement("tr");
        tr.innerHTML = `
            <td>${nomen}</td>
            <td>${feature}</td>
            <td>${qty} шт.</td>
        `;
        tbody.appendChild(tr);
        }
    });

    // Вывод итогов
    if (outRrc)    outRrc.textContent    = fmt(sumRrc);
    if (outDealer) outDealer.textContent = fmt(sumDealer);
    if (outWay) outWay.textContent = fmt(sumWay);
    if (outProduction) outProduction.textContent = fmt(sumProduction);
    if (outPreorder) outPreorder.textContent = fmt(sumPreorder);

    // Бейдж «Экономия» рядом с дилерской суммой
    const badge = document.getElementById("savings-badge");
    var savings = 0;

    const badge_preorder = document.getElementById("savings-badge-preorder");
    var savings_preorder = 0;

    if (outProduction) {
        savings = Math.max(sumRrc - sumProduction, 0);
    } else {
        savings = Math.max(sumRrc - sumDealer, 0);
    }
    if (outPreorder) {
        savings_preorder = Math.max(sumRrc - sumPreorder, 0);
    }
    if (badge) {
        if (savings > 0) {
            if (outProduction) {
                badge.textContent = `Экономия по цене производства: ${fmt(savings)} ₽`;
            } else {
                badge.textContent = `Экономия по цене дилера: ${fmt(savings)} ₽`;
            }
            badge.style.visibility = "visible";
        } else {
            badge.style.visibility = "hidden";
        }
    }
    if (badge_preorder) {
        if (savings_preorder > 0) {
            badge_preorder.textContent = `Экономия предзаказа: ${fmt(savings_preorder)} ₽`;
            badge_preorder.style.visibility = "visible";
        } else {
            badge_preorder.style.visibility = "hidden";
        }
    }

    // Показ/скрытие блока «Вы выбрали»
    const hasRows = tbody && tbody.children.length > 0;
    if (summaryWrap) summaryWrap.style.display = hasRows ? "block" : "none";
    if (summaryTitle) {
        summaryTitle.innerText = hasRows ? "Вы выбрали:" : "Здесь будет список выбранных товаров";
    }
}

// События пересчёта
document.addEventListener("input",  e => { if (e.target.matches('input[name^="order_"]')) recalcTotals(); });
document.addEventListener("change", e => { if (e.target.matches('input[name^="order_"]')) recalcTotals(); });

// Если у тебя есть код переключения табов — после переключения тоже пересчитать:
document.querySelectorAll(".tab").forEach(tab => {
    tab.addEventListener("click", () => setTimeout(recalcTotals, 0));
});

// Первый расчёт
recalcTotals();

const clearSelection = document.getElementById("clear-selection");
if (clearSelection) {
clearSelection.addEventListener("click", () => {
    // Обнуляем все поля заказа
    document.querySelectorAll('input[name^="order_"]').forEach(inp => {
    inp.value = "";
    });
    // Пересчитываем суммы и "Вы выбрали"
    recalcTotals();
});
}
